exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".advert-detail[data-v-0cc0b4de]{padding:20px 56px}.detail-item[data-v-0cc0b4de]{margin-bottom:15px}.detail-item img[data-v-0cc0b4de]{width:300px}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader!./~/vue-loader/lib/style-rewriter.js?id=data-v-0cc0b4de&scoped=true!./~/vue-loader/lib/selector.js?type=styles&index=0!./src/components/yunying/advert/advertData.vue
// module id = 436
// module chunks = 0